export default __webpack_public_path__ + "locales/ja-JP/UploadPanel.json?hash=ae98f6ab0b82c0641cc132fca1ea0cc0";